module.exports = __webpack_public_path__ + "static/Marketplace@2x-min-8e77d4493235a178f5d08680f0d8676f.png";